import {environment} from "../environments/environment";

export function getEndpointUrl() {
  if (environment.production && !window.location.hostname.includes('localhost')) {
    return `https://api.${window.location.hostname}`
  } else {
    // Dev: point at the local gateway (docker-compose.dev.yaml, :7080) so a single origin fans out to the
    // monolith and the microservices — `/api/forms/*` -> service_forms, everything else -> the monolith.
    return "http://localhost:7080";
  }
}

export const ENDPOINT_URL_PROVIDER = {
  provide: 'BASE_URL',
  useFactory: getEndpointUrl,
  deps: []
}
